import React, { useEffect, useState } from "react";
import Steps from "components/CustomWidgets/steps";
import BrandLogo from "assets/images/svg/click-for-marry.svg";
import "./style.scss";
import { Form } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import AboutBride from "./components/AboutBride";
import PhysicalMaritalDetails from "./components/PhysicalMaritalDetails";
import CareerDetails from "./components/CareerDetails";
import PartnerPreferences from "./components/PartnerPreferences";
import { clearStepFormStorage } from "utils/clearStepFormStorage";
import { retrieveToken } from "utils/storage";

function OnboardStep() {
  const [aboutBrideForm] = Form.useForm();
  const [physicalDetailsForm] = Form.useForm();
  const [careerDetailsForm] = Form.useForm();
  const [partnerPrefsForm] = Form.useForm();
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(0);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 991);
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 991);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Redirect check
  useEffect(() => {
    const onboardingStep = parseInt(retrieveToken("onboarding_steps"), 10);

    if (onboardingStep === 8) {
      navigate("/home");
    } else {
      setShouldRender(true);
    }
  }, []);

  const steps = [
    { title: "About profile", content: <AboutBride form={aboutBrideForm} /> },
    {
      title: "Physical and marital details",
      content: <PhysicalMaritalDetails form={physicalDetailsForm} />,
    },
    {
      title: "Career details",
      content: <CareerDetails form={careerDetailsForm} />,
    },
    {
      title: "Partner preferences",
      content: <PartnerPreferences form={partnerPrefsForm} />,
    },
  ];

  const visibleSteps = isMobileView
    ? steps.map((step) => ({ ...step, title: "" }))
    : steps;

  const forms = [
    aboutBrideForm,
    physicalDetailsForm,
    careerDetailsForm,
    partnerPrefsForm,
  ];

  if (!shouldRender) return null;

  return (
    <div className="steps-wrapper">
      <div className="custom-header">
        <div className="container-section container">
          <span className="brand-logo">
            <img className="logo" src={BrandLogo} alt="Logo" />
          </span>
          <div className="heading-wrapper flex flex-col justify-center items-center gap-3 pb-8">
            <h1 className="font-body-xl-white stepper-heading">
              Fill in your basic details
            </h1>
            <p className="sub-title">
              Get started on your journey to find the right match!
            </p>
          </div>
          <div className="active-step-title text-lg font-medium text-white">
            {steps[currentStep]?.title}
          </div>
        </div>
      </div>
      <Steps
        forms={forms}
        className={`stepper-class`}
        buttonWrapperClass={`buttons-frame`}
        contentClass={`content-frame flex justify-around`}
        steps={visibleSteps}
        onStepChange={(step) => setCurrentStep(step)}
        onFinalNext={() => {
          clearStepFormStorage();
          window.scrollTo(0, 0);
          navigate("/onboard/upload");
        }}
      />
    </div>
  );
}

export default OnboardStep;
